import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="fintel-status-map"
//
// Add/remove rows for the Fintel status mapping. Same shape as data-export-fields, minus sorting:
// the mapping is a lookup, so row order carries no meaning.
//
// Only rows the operator types are removable. Rows for values this destination has already
// received are rendered without a remove button — deleting one would not stop the value arriving,
// it would only unmap it, and the next render would bring it back unmapped anyway.
export default class extends Controller {
  static targets = ["container", "template"]

  addRow(event) {
    event.preventDefault()

    const row = this.templateTarget.content.cloneNode(true).querySelector(".fintel-status-row")

    this.containerTarget.appendChild(row)
    this.updateIndexes()
    row.querySelector("input[type=text]")?.focus()
  }

  removeRow(event) {
    event.preventDefault()

    event.target.closest(".fintel-status-row").remove()
    this.updateIndexes()
  }

  // Rails builds the hash from the indexes in the field names, so they have to stay sequential
  // and unique after any add or remove.
  updateIndexes() {
    this.containerTarget.querySelectorAll(".fintel-status-row").forEach((row, index) => {
      row.querySelectorAll("input, select").forEach((input) => {
        if (input.name) {
          input.name = input.name.replace(/\[status_tier_map_entries\]\[\d+\]/, `[status_tier_map_entries][${index}]`)
        }
        if (input.id) {
          input.id = input.id.replace(/_status_tier_map_entries_\d+_/, `_status_tier_map_entries_${index}_`)
        }
      })
    })
  }
}
